import * as z from "zod";

export const resendMagicLink = {
  name: "resendMagicLink" as const,
  input: z.object({ partnerId: z.string() }),
  output: z.object({
    magicLinkSent: z.boolean(),
    magicLinkError: z.string().optional(),
  }),
};
